import { z } from "zod";

export const credentialsSchema = z.object({
	email: z.string().min(1, "email.required").pipe(z.email("email.invalid")),
	password: z.string().min(1, "password.required").max(24, "password.invalid"),
	rememberMe: z.boolean().optional(),
});

export const confirmationSchema = z.object({
	code: z
		.string()
		.min(1, "confirmation.required")
		.max(8, "confirmation.invalid"),
});

export const phoneVerificationSchema = z.object({
	code: z.string().min(1, "verification.required"),
});

export const verificationSchema = z.object({
	code: z
		.string()
		.min(1, "verification.required")
		.max(8, "verification.invalid"),
});

export const totpSetupSchema = z.object({
	code: z.string().min(1, "totp_setup.required").max(6, "totp_setup.invalid"),
});

export const signInSchema = z.object({
	...credentialsSchema.shape,
	...confirmationSchema.shape,
	...phoneVerificationSchema.shape,
	...verificationSchema.shape,
});

export type CredentialsData = z.infer<typeof credentialsSchema>;
export type ConfirmationData = z.infer<typeof confirmationSchema>;
export type PhoneVerificationData = z.infer<typeof phoneVerificationSchema>;
export type TotpSetupData = z.infer<typeof totpSetupSchema>;
export type VerificationData = z.infer<typeof verificationSchema>;
export type SignInData = z.infer<typeof signInSchema>;
